// SPDX-License-Identifier: GPL-3.0-or-later
// The layout rule of the game page, as a pure function. The stage is a column: the HUD first, then
// the playfield. The canvas fills the playfield, so the table never sits under the HUD. The page
// measures the playfield and passes the numbers here.

/** The size of a box in CSS pixels, as `getBoundingClientRect` gives it. */
export interface BoxSize {
  readonly width: number;
  readonly height: number;
}

/** A side of the canvas is at least this many CSS pixels, also for a box that is not laid out yet. */
export const MIN_CANVAS_SIDE_PX = 1;

function side(value: number): number {
  return Number.isFinite(value)
    ? Math.max(MIN_CANVAS_SIDE_PX, Math.floor(value))
    : MIN_CANVAS_SIDE_PX;
}

/** The canvas size for a playfield box: whole pixels, and never zero (a zero side breaks the renderer). */
export function canvasSize(playfield: BoxSize): BoxSize {
  return { width: side(playfield.width), height: side(playfield.height) };
}
